import SectionHeading from '@/components/base/SectionHeading';
import ArticleLink from '@/components/feature/ArticleLink';
import AnalysisCandleChart from '@/pages/forex-analysis/components/AnalysisCandleChart';
import {
  analysisChartCandles,
  chartCaseMarkers,
  chartCaseSteps,
  chartLevels,
} from '@/mocks/forexAnalysisPage';

export default function ChartCaseStudy() {
  return (
    <section id="chart-case" className="scroll-mt-[7.5rem] md:scroll-mt-[9rem] border-b border-background-200 bg-background-100/60">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20 lg:px-10">
        <SectionHeading
          eyebrow="กรณีศึกษาจากกราฟ"
          title="ตัวอย่างการวิเคราะห์กราฟ Forex"
          subtitle="กราฟตัวอย่างหนึ่งภาพ อ่านได้หลายชั้น ตั้งแต่ทิศทางหลัก ไปจนถึงจุดที่ราคาผ่านระดับสำคัญ ตัวเลขในภาพคือลำดับการอ่าน ไม่ใช่สัญญาณซื้อขาย"
        />

        <div className="mt-10 grid grid-cols-1 gap-8 md:mt-12 lg:grid-cols-[1.06fr_1fr] lg:gap-12">
          <div className="min-w-0">
            <figure className="rounded-xl border border-background-200 bg-background-50 p-3 md:p-4">
              <div className="flex flex-wrap items-center justify-between gap-2 border-b border-background-200 pb-3">
                <div className="flex items-center gap-2">
                  <span className="font-num text-sm font-semibold text-foreground-950">EUR/USD</span>
                  <span className="rounded-sm bg-background-100 px-1.5 py-0.5 font-num text-[10px] font-semibold text-foreground-600">
                    H1
                  </span>
                </div>
                <span className="text-[10px] font-medium text-foreground-500">ภาพวาดเพื่อการสอน</span>
              </div>

              <div className="mt-3 h-[280px] w-full sm:h-[330px] lg:h-[360px]">
                <AnalysisCandleChart
                  candles={analysisChartCandles}
                  support={chartLevels.support}
                  resistance={chartLevels.resistance}
                  markers={chartCaseMarkers}
                  ariaLabel="แผนภาพกราฟแท่งเทียนเพื่อการสอน พร้อมหมายเลข 1 แนวโน้มราคา 2 แนวรับ 3 แนวต้าน และ 4 จุดที่ราคาผ่านระดับสำคัญ"
                />
              </div>

              <figcaption className="mt-3 grid grid-cols-1 gap-x-4 gap-y-2 border-t border-background-200 pt-3 sm:grid-cols-2">
                {chartCaseMarkers.map((marker) => (
                  <span key={marker.no} className="flex items-start gap-2 text-[11px] leading-relaxed text-foreground-600">
                    <span className="mt-px flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-background-100 font-num text-[10px] font-semibold text-foreground-800">
                      {marker.no}
                    </span>
                    {marker.label}
                  </span>
                ))}
              </figcaption>
            </figure>

            <p className="mt-3 flex items-start gap-2 px-1 text-[11px] leading-relaxed text-foreground-500">
              <i className="ri-alert-line mt-0.5 shrink-0 text-sm" aria-hidden="true" />
              ภาพนี้ไม่ใช่ราคาเรียลไทม์ ไม่ใช่สัญญาณซื้อหรือขาย และไม่ใช่การรับประกันทิศทางราคาในอนาคต ใช้เพื่ออธิบายวิธีการอ่านกราฟเท่านั้น
            </p>
          </div>

          <div className="min-w-0">
            <ol className="flex flex-col divide-y divide-background-200 border-y border-background-200">
              {chartCaseSteps.map((step) => (
                <li key={step.no} className="flex gap-4 py-4 first:pt-3 last:pb-3">
                  <span className="mt-0.5 font-num text-xs font-semibold text-accent-700">{step.no}</span>
                  <div className="min-w-0">
                    <h3 className="font-heading text-sm font-semibold leading-snug text-foreground-950 md:text-base">
                      {step.title}
                    </h3>
                    <p className="mt-1.5 text-[13px] leading-relaxed text-foreground-600">{step.body}</p>
                  </div>
                </li>
              ))}
            </ol>

            <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:items-center">
              <ArticleLink
                to="/how-to-analyze-forex-chart"
                className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                อ่านคู่มือการวิเคราะห์กราฟ
                <i className="ri-arrow-right-line text-base" aria-hidden="true" />
              </ArticleLink>
              <span className="text-xs leading-relaxed text-foreground-500">
                บทความเต็มมีลำดับการทำซ้ำได้ทุกครั้งที่เปิดกราฟ
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}